<div *ngIf="_errorMessages.length" class="mainWrapper">
  <ul class="p-message p-message-error">
    <li *ngFor="let errorMessage of _errorMessages" [innerHTML]="errorMessage"></li>
  </ul>
</div>
